import { api } from './api';

export interface Praca {
  id: number;
  nomePraca: string;
  nomeFuncionario: string;
  codFuncionario: number;
  dataVinculo: string;
  ativo?: 'SIM' | 'NAO';
}

export interface PracaRequest {
  id?: number;
  nomePraca: string;
  codFuncionario: number;
  dataVinculo: string;
}

export const pracaService = {
  // Buscar todas as praças
  getAll: async (): Promise<Praca[]> => {
    const response = await api.get<Praca[]>('/api/Praca/GetAll');
    return response.data;
  },

  // Buscar praça por ID
  getById: async (id: number): Promise<Praca> => {
    const response = await api.get<Praca>(`/api/Praca/GetById?id=${id}`);
    return response.data;
  },

  // Buscar praças por funcionário
  getByIdFuncionario: async (idFuncionario: number): Promise<Praca[]> => {
    const response = await api.get<Praca[]>(`/api/Praca/GetByIdFuncionario?idFuncionario=${idFuncionario}`);
    return response.data;
  },

  // Salvar nova praça
  save: async (praca: PracaRequest): Promise<Praca> => {
    const response = await api.post<Praca>('/api/Praca/Salvar', praca);
    return response.data;
  },
};
